module.exports = __webpack_public_path__ + "static/media/d-company-logo.8437254b.png";